import React from 'react';
import { Box, Button, ButtonMode } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { SortingIcon } from '@epi-shared/components';
import { getTopupTable } from '@epi-store/topup/topup.selectors';
import { topupSliceActions } from '@epi-store/topup/topup.slice';

export const TopupShowTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showTable = useSelector(getTopupTable);

  return (
    <Box id="deposit_money_topup_step_three_show_table_button">
      <Button
        mode={ButtonMode.Secondary}
        onClick={() => {
          dispatch(topupSliceActions.toggleShowTable(!showTable));
        }}
        id="deposit_money_topup_step_three_show_table_button"
      >
        <Box
          display="flex"
          gap={1}
          alignItems={showTable ? 'inherit' : 'flex-end'}
        >
          <SortingIcon isAscending={!showTable} />
          {t(
            'containers.deposit_money.topup_tab.form.employees.select_employees'
          )}
        </Box>
      </Button>
    </Box>
  );
};
